/**
 * Initializes the target element as a portal.
 *
 * @param {HTMLElement} $target
 */
const portal = ($target) => {
    const name = $target.getAttribute('data-sm-portal');
    const $elements = document.querySelectorAll(`[data-sm-portal-target='${name}']`);

    Array.prototype.forEach.call($elements, $element => {
        $element.removeAttribute('data-sm-portal-target');
        $target.appendChild($element);
        $element.classList.remove('sm-portal--cloaked');
    });
};

/**
 * Intialize method.
 * Portals are used to move DOM elements from one place to another.
 */
export default () => {
    const $portals = document.querySelectorAll('[data-sm-portal]');
    Array.prototype.forEach.call($portals, portal.bind(undefined));
};
